<template>
  <sticky-header-layout>
    <template #header>
      <div class="action-container">
        <div class="pagination-container">
        </div>
        <div class="button-container">
          <el-button
            :disabled="isLoading"
            icon="el-icon-close"
            size="mini"
            @click="resetFiliter"
          >{{ $t('button.resetFilter') }}</el-button>
          <el-button
            :disabled="isLoading"
            type="primary"
            icon="el-icon-search"
            size="mini"
            @click="handleSearch"
          >{{ $t('button.search') }}</el-button>
        </div>
      </div>
      <div class="filter-container">
        <div class="filter-item">
          <label-wrapper label="Merchant">
            <el-select
              v-model="filter.merchant_id"
              :disabled="isLoading"
              :loading="isFetchingMerchants"
              filterable
            >
              <el-option
                v-for="item in merchants"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </label-wrapper>
        </div>
        <div class="filter-item">
          <label-wrapper label="Status">
            <el-select
              v-model="filter.status"
              :disabled="isLoading"
              filterable
            >
              <el-option
                v-for="item in status"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </label-wrapper>
        </div>
        <div class="filter-item">
          <label-wrapper label="Coupon Code">
            <el-input
              :disabled="isLoading"
              v-model="filter.coupon"
              clearable
            />
          </label-wrapper>
        </div>
      </div>
    </template>

    <el-table
      :data="tableData"
      v-loading="isLoading"
      stripe
      border
      style="width: 100%">
      <el-table-column
        prop="merchant_name"
        label="Merchant"
        width="180">
      </el-table-column>
      <el-table-column
        prop="title"
        label="Title"
        width="180">
      </el-table-column>
      <el-table-column
        prop="status"
        label="Status"
        width="180">
      </el-table-column>
      <el-table-column
        prop="start_at"
        label="Start Date"
        width="180">
      </el-table-column>
      <el-table-column
        prop="end_at"
        label="End Date"
        width="180">
      </el-table-column>
      <el-table-column
        prop="quota"
        label="Quota"
        width="180">
      </el-table-column>
      <el-table-column
        prop="per_user_quota"
        label="Quota per user"
        width="180">
      </el-table-column>
      <el-table-column
        fixed="right"
        label="Action"
        align="center"
        min-width="100"
      >
        <template slot-scope="scope">
          <el-button
            type="info"
            icon="el-icon-view"
            circle
            @click="showCouponDetail(scope.row)"
          />
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      :visible.sync="showCouponDetailModal"
      title="Coupon Detail"
    >
      <!-- <div>Order Number: {{ selectedOrderNumber }}</div>
      <div>Email: {{ selectedOrderMemberEmail }}</div>
      <br/> -->
      
      <el-table :data="selectedCouponData">
        <el-table-column
          prop="title"
          label="Title"
          width="180">
        </el-table-column>
       <el-table-column
          prop="paid_by"
          label="Paid By"
          width="180">
        </el-table-column>
       <el-table-column
          prop="is_first_purchase_only"
          label="First Purchase"
          width="180">
        </el-table-column>
       <el-table-column
          prop="is_device_first_purchase_only"
          label="Device First Purchase"
          width="180">
        </el-table-column>
       <el-table-column
          prop="is_app_only"
          label="App Purchase"
          width="180">
        </el-table-column>
        <el-table-column
          prop="discount_type"
          label="Discount Type"
          width="180">
        </el-table-column>
        <el-table-column
          prop="discount_value_text"
          label="Amount"
          width="180">
        </el-table-column>
        <el-table-column
          prop="start_at"
          label="Start Date"
          width="180">
        </el-table-column>
        <el-table-column
          prop="end_at"
          label="End Date"
          width="180">
        </el-table-column>
        <el-table-column
          prop="apply_before_product_discount"
          label="Apply Before Product Discount"
          width="180">
        </el-table-column>
        <el-table-column
          prop="currency"
          label="Currency"
          width="180">
        </el-table-column>
        <el-table-column
          prop="minimum_purchase_amount"
          label="Minimun Purchase Amount"
          width="180">
        </el-table-column>
        <el-table-column
          prop="minimum_purchase_quantity"
          label="Minimum Purchase Quantity"
          width="180">
        </el-table-column>
        <el-table-column
          prop="one_time_promotion"
          label="One Time Promotion"
          width="180">
        </el-table-column>
        <el-table-column
          prop="exclude_shipping_fee"
          label="Exclude Shipping Fee"
          width="180">
        </el-table-column>
        <el-table-column
          prop="quota"
          label="Quota"
          width="180">
        </el-table-column>
        <el-table-column
          prop="status"
          label="Status"
          width="180">
        </el-table-column>
        <el-table-column
          prop="per_user_quota"
          label="Quota per User"
          width="180">
        </el-table-column>
        <el-table-column
          prop="priority"
          label="Priority"
          width="180">
        </el-table-column>
      </el-table>
    </el-dialog>

  </sticky-header-layout>
</template>

<script>
// import format from 'date-fns/format'

import LabelWrapper from '../../components/form/LabelWrapper.vue'

import MarketplaceService from '../../api/marketplace'
import useTablePaging from '../../mixins/useTablePaging'
// import { getUTCDate } from '../../utils/helper'

export default {
  name: 'Coupon',
  components: {
    LabelWrapper,
  },
  mixins: [useTablePaging],
  data() {
    return {
      filter: {
        merchant_id: '',
        coupon: '',
        status: '',
      },

      isLoading: false,

      isFetchingMerchants: false,
      merchants: [],
      tableData: [],
      showCouponDetailModal: false,
      selectedCouponData: [],
      status: [
        {name: 'Disabled', id: 'Disabled'},
        {name: 'Enabled', id: 'Enabled'},
      ]
    }
  },
  async mounted() {
    this.fetchMerchants()
    this.getList()
  },
  methods: {
    async fetchMerchants() {
      this.isFetchingMerchants = true
      try {
        const response = await MarketplaceService.getMerchantList()
        this.merchants = [
          { id: '', name: this.$t('mpOrder.all') },
          ...response.data,
        ]
      } finally {
        this.isFetchingMerchants = false
      }
    },
    async getList() {
      this.isLoading = true
      try{ 
        const res = await MarketplaceService.getAllCoupon()
        for (const coupon of res.data) {
          if (coupon.status === 0) {
            coupon.status = 'Disabled'
          } else {
            coupon.status = 'Enabled'
          }

          if (coupon.is_first_purchase_only === 0) {
            coupon.is_first_purchase_only = 'No'
          } else {
            coupon.is_first_purchase_only = 'Yes'
          }

          if (coupon.is_device_first_purchase_only === 0) {
            coupon.is_device_first_purchase_only = 'No'
          } else {
            coupon.is_device_first_purchase_only = 'Yes'
          }

          if (coupon.is_app_only === 0) {
            coupon.is_app_only = 'No'
          } else {
            coupon.is_app_only = 'Yes'
          }

          const startDate = new Date(coupon.start_at.replace(/\s/, 'T'))
          const startMonth = startDate.getMonth()+1
          const startDay = startDate.getDate()
          const startYear = startDate.getFullYear()
          coupon.start_at = `${startDay}/${startMonth}/${startYear}`

          const endDate = new Date(coupon.end_at.replace(/\s/, 'T'))
          const endMonth = endDate.getMonth()+1
          const endDay = endDate.getDate()
          const endYear = endDate.getFullYear()
          coupon.end_at = `${endDay}/${endMonth}/${endYear}`

          coupon.quota = `${coupon.quota_used}/${coupon.quota}`
        }
        
        this.tableData = [
          ...res.data
        ]
      } catch(e) {
        console.log(e)
      } finally {
        this.isLoading = false
      }
    },
    async showCouponDetail(row) {
      const res = await MarketplaceService.getCouponDetails(row.id)

      for (const coupon of res.data) {
        if (coupon.apply_before_product_discount === 0) {
          coupon.apply_before_product_discount = 'No'
        } else {
          coupon.apply_before_product_discount = 'Yes'
        }
        if (coupon.one_time_promotion === 0) {
          coupon.one_time_promotion = 'No'
        } else {
          coupon.one_time_promotion = 'Yes'
        }
        if (coupon.exclude_shipping_fee === 0) {
          coupon.exclude_shipping_fee = 'No'
        } else {
          coupon.exclude_shipping_fee = 'Yes'
        }
        if (coupon.status === 0) {
          coupon.status = 'Disabled'
        } else {
          coupon.status = 'Enabled'
        }
        if (coupon.status === 0) {
          coupon.status = 'Disabled'
        } else {
          coupon.status = 'Enabled'
        }

        if (coupon.is_first_purchase_only === 0) {
          coupon.is_first_purchase_only = 'No'
        } else {
          coupon.is_first_purchase_only = 'Yes'
        }

        if (coupon.is_device_first_purchase_only === 0) {
          coupon.is_device_first_purchase_only = 'No'
        } else {
          coupon.is_device_first_purchase_only = 'Yes'
        }

        if (coupon.is_app_only === 0) {
          coupon.is_app_only = 'No'
        } else {
          coupon.is_app_only = 'Yes'
        }

        if (coupon.discount_type === 1) {
          coupon.discount_type = 'Percentage Discount'
        } else if (coupon.discount_type === 2) {
          coupon.discount_type = 'Cash Discount'
        } else {
          coupon.discount_type = 'Free Shipping'
        }
        const startDate = new Date(coupon.start_at.replace(/\s/, 'T'))
        const startMonth = startDate.getMonth()+1
        const startDay = startDate.getDate()
        const startYear = startDate.getFullYear()
        coupon.start_at = `${startDay}/${startMonth}/${startYear}`

        const endDate = new Date(coupon.end_at.replace(/\s/, 'T'))
        const endMonth = endDate.getMonth()+1
        const endDay = endDate.getDate()
        const endYear = endDate.getFullYear()
        coupon.end_at = `${endDay}/${endMonth}/${endYear}`

        coupon.quota = `${coupon.quota_used}/${coupon.quota}`
      }
      res.data[0].paid_by = row.paid_by

      this.selectedCouponData = [
        ...res.data
      ]

      this.showCouponDetailModal = true
    },
    handleSearch() {
      let filterArr = []

      if (this.filter.merchant_id == '' && this.filter.status == '' && this.filter.coupon == '') {
        this.getList()
      }
      if (this.filter.merchant_id && this.filter.status == '' && this.filter.coupon == '') {
        for (const item of this.tableData) {
          if (item.merchant_id == this.filter.merchant_id) {
            filterArr.push(item)
          }
        }
      } else if (this.filter.merchant_id == '' && this.filter.status && this.filter.coupon == '') {
          for (const item of this.tableData) {
            if (item.status == this.filter.status) {
              filterArr.push(item)
            }
          }
      } else if (this.filter.merchant_id == '' && this.filter.status == '' && this.filter.coupon) {
          for (const item of this.tableData) {
            if (item.code == this.filter.coupon) {
              filterArr.push(item)
            }
          }
      }
      this.tableData = filterArr
    },
    resetFiliter() {
      this.filter =  {
        merchant_id: '',
        coupon: '',
        status: '',
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/table.scss";

.filter-container {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  flex-grow: 1;
  .filter-title {
    font-size: 13px;
    margin-right: 5px;
  }
}

section {
  .filter-item {
    margin: 3px 0;
    width: 100%;
    @include mobile {
      margin: 3px 5px;
      width: calc(100% / 3 - 10px);
    }
    @include tablet {
      width: calc(100% / 4 - 10px);
    }
    @include desktop {
      width: calc(100% / 6 - 10px);
    }
  }
  .data-picker-container {
    position: relative;
    // Make the hack button span the whole parent container.
    .absolute-view {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
}

.data-picker-container {
  width: 200px;
}

::v-deep {
  .el-table__row {
    .cell {
      a {
        text-decoration: underline;
      }
    }
  }
}

</style>
